export function userReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_USER":            
                
            return {[payload.user_id] : payload, ...state};
        case "GET_USERS":
            let list = state === "" ? payload : Object.assign(payload, state);
            return list
        case "GET_RESUME_USERS":
            
            return payload;
        case "UPDATE_USER":
            let list2 = Object.assign({}, state)
            list2[payload.user_id] = payload
            
            return list2;
        case "DELETE_USER":
            let list3 = Object.assign({}, state)
            delete list3[payload.user_id]
            
            return list3;

        case "DEBIT_USER_ACCOUNT":
            let list4 = Object.assign({}, state)
            let user = list4[payload.user_id]

            console.log('====================================');
            console.log("DEBIT_USER_ACCOUNT", payload, user, user.account );
            user.account -= payload.amount
            console.log("DEBIT_USER_ACCOUNT", payload, user, user.account );
            console.log('====================================');

            list4[payload.user_id] = user
            
            return list4;
        
        default:
            return state;
    }
    
}